export enum ElementTypeControle {
  LOT_RECEPTION = "LOT_RECEPTION",
  PREPARATION_EXPE = "PREPARATION_EXPE",
  DECHARGEMENT = "DECHARGEMENT",
  EXPEDITION = "EXPEDITION",
  LIBERATOIRE = "LIBERATOIRE",
  CHARGEMENT = "CHARGEMENT",
  PRODUCTION = "PRODUCTION",
  START_OPE = "START_OPE",
  END_OPE = "END_OPE",

  START_OPE_GENERAUX = "START_OPE_GENERAUX",
  END_OPE_GENERAUX = "END_OPE_GENERAUX",
  LOT_RECEPTION_GENERAUX = "LOT_RECEPTION_GENERAUX",
  PREPARATION_EXPE_GENERAUX = "PREPARATION_EXPE_GENERAUX",
  DECHARGEMENT_GENERAUX = "DECHARGEMENT_GENERAUX",
  DECHARGEMENT_ARTICLE_GENERAUX = "DECHARGEMENT_ARTICLE_GENERAUX",
  EXPEDITION_GENERAUX = "EXPEDITION_GENERAUX",
  LIBERATOIRE_GENERAUX = "LIBERATOIRE_GENERAUX",
  CHARGEMENT_GENERAUX = "CHARGEMENT_GENERAUX",
  CHARGEMENT_ARTICLE_GENERAUX = "CHARGEMENT_ARTICLE_GENERAUX",
  CHARGEMENT_UNITE_GENERAUX = "CHARGEMENT_UNITE_GENERAUX",
  PRODUCTION_GENERAUX = "PRODUCTION_GENERAUX",

  PROCESS = "PROCESS",
  SUIVI_LOT = "SUIVI_LOT",
  CHECKLIST = "CHECKLIST",
}

export enum ElementTypeControleGeneraux {
  START_OPE_GENERAUX = "START_OPE_GENERAUX",
  END_OPE_GENERAUX = "END_OPE_GENERAUX",
  LOT_RECEPTION_GENERAUX = "LOT_RECEPTION_GENERAUX",
  PREPARATION_EXPE_GENERAUX = "PREPARATION_EXPE_GENERAUX",
  DECHARGEMENT_GENERAUX = "DECHARGEMENT_GENERAUX",
  DECHARGEMENT_ARTICLE_GENERAUX = "DECHARGEMENT_ARTICLE_GENERAUX",
  EXPEDITION_GENERAUX = "EXPEDITION_GENERAUX",
  LIBERATOIRE_GENERAUX = "LIBERATOIRE_GENERAUX",
  CHARGEMENT_GENERAUX = "CHARGEMENT_GENERAUX",
  CHARGEMENT_ARTICLE_GENERAUX = "CHARGEMENT_ARTICLE_GENERAUX",
  CHARGEMENT_UNITE_GENERAUX = "CHARGEMENT_UNITE_GENERAUX",
  PRODUCTION_GENERAUX = "PRODUCTION_GENERAUX",
}


